import axios from 'axios';

const setAuthToken = token => {
    if(token) {
        console.log('Setting auth token....')
        // Knox expects "Token <token>"
        axios.defaults.headers.common['Authorization'] = 'Token ' + token;
    } else {
        //Delete auth header
        delete axios.defaults.headers.common['Authorization'];
    }
};

export default setAuthToken;